<script setup lang="ts">
    type Props = {
        text?: string | null;
    };

    const props = withDefaults(defineProps<Props>(), {
        text: null
    });
</script>

<template>
    <b-tooltip
        :label="props.text"
        position="is-top">
        <b-icon
            icon="help"
            class="helpIcon"
            size="is-small" />
        <template
            v-if="!props.text"
            #content>
            <slot
                name="helpContent" />
        </template>
    </b-tooltip>
</template>

<style scoped>
    .helpIcon {
        cursor: help;
    }
</style>
